import { SERVER_URLS } from "../../../appConstants";
import { buildUrl } from "../../../ReusableFunctions/reusableFunctions";
import { getToken } from "../../authentication";
import { checklocalMicroSip } from "../Telecaller/callingHistory";

export const getCrmleadsLogByLeadId = async (Id, Filter) => {
    try {
        const token = getToken();
        let url = buildUrl(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/calls/${Id}`, {
            orderBy: Filter?.orderBy || undefined,
            orderType: Filter?.orderType || undefined
        })
        const response = await fetch(url,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const res = await response.json();
        if (!response.ok) {
            throw (res.message);
        }
        return res.leads;
    } catch (err) {
        throw err;
    }
}

export const getCrmleadsLog = async (filter) => {
    try {
        const token = getToken();
        const url = buildUrl(SERVER_URLS.BACKEND_SERVER + '/bhumeet_team/crm/calls', {
            fromDate: filter.fromDate ? filter.fromDate : undefined,
            toDate: filter.toDate ? filter.toDate : undefined,
            pageNumber: filter.currentPage ? filter.currentPage : undefined,
            pageSize: filter.pageSize ? filter.pageSize : undefined,
            interval: filter.interval ? filter.interval : undefined
        });
        const response = await fetch(url,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const res = await response.json();
        if (!response.ok) {
            throw (res.message);
        }
        return res;
    } catch (err) {
        throw err;
    }
}

export const CreateCrmleads = async (Data) => {
    try {
        const token = getToken();
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/leads`,
            {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                }, body: Data
            }
        );
        const res = await response.json();
        if (!response.ok) {
            throw (res.message);
        }
        return res.message;
    } catch (err) {

        throw err;
    }
}



export const InitiateCall = async (toCallNumber, leadId, fromCall, campName, target) => {
    try {
        const token = getToken();

        let checkService = await checklocalMicroSip(fromCall);

        if (!checkService.vpn) {
            throw "Please start Your VPN service.";
        } else if (!checkService.microSip) {
            throw "Please start Your MicroSip application.";
        }

        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/calls`,
            {
                method: "post",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ toCall: toCallNumber, leadId, fromCall, campName, target })
            }
        )

        const res = await response.json();
        if (!response.ok) {
            throw (res.message);
        }
        return res;
    } catch (err) {

        throw err;

    }
}


export const updateCrmleadslog = async (Data) => {
    try {
        const token = getToken();
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/calls/updatelog`,
            {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }, body: JSON.stringify(Data)
            }
        );
        const res = await response.json();
        if (!response.ok) {
            throw (res.message);
        }
        return res.message;
    } catch (err) {

        throw err;
    }
}


export const sendAppLinkToUser = async (mobileNumber) => {
    try {
        const token = getToken();
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/send/applink`,
            {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }, body: JSON.stringify({ mobileNumber })
            }
        );
        const res = await response.json();
        if (!response.ok) {
            throw (res.message);
        }
        return res.message;
    } catch (err) {
        throw err;
    }
}

export const createFollowUp = async (Data) => {
    console.log("data inside create followup api", Data);
    try {
        const token = getToken();
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/calls/create/followup`,
            {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }, body: JSON.stringify(Data)
            }
        );
        const res = await response.json();
        console.log("res", res);
        if (!response.ok) {
            throw (res.message);
        }
        return res.message;
    } catch (err) {

        throw err;
    }
}
